import * as React from "react";

import { DataSourceAddressAutocompleteControllerProvider } from "./data-source-address-autocomplete-controller";

export const DataSourceAddressAutocompleteProvider: React.FunctionComponent = (
  props
) => {
  return (
    <DataSourceAddressAutocompleteControllerProvider>
      {props?.children || []}
    </DataSourceAddressAutocompleteControllerProvider>
  );
};
